import gql from "graphql-tag";

export const ADD_PURCHASED_PHOTO = gql`
    mutation purchasePhoto($input: PurchasePhotoInput) {
        purchasePhoto(input: $input) {
            ok
            errors
        }
    }
`;
